import { useEffect } from "react";

//  const ONE_HOUR = 10 * 10 * 1000;
 const ONE_HOUR = 60 * 60 * 1000;

const AutoClearStorage = ({ children }) => {
  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(() => {
        console.log("Clearing localStorage due to inactivity...");
        localStorage.clear();
      }, ONE_HOUR);
    };

    // Track user activity
    const events = ["click", "mousemove", "keydown", "scroll"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // Start timer initially
    resetTimer();

    // Cleanup
    return () => {
      if (timeout) clearTimeout(timeout);
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  return children;
};

export default AutoClearStorage;